/**
 * ContactInfoPanel — the right-hand column of the marketing contact grid:
 * a section title plus the caller-supplied `<ContactInfoItem>` rows.
 *
 * Extracted from `<ContactPage>` together with `<ContactInfoItem>` to cut the
 * page's JSX nesting depth (`web/render-method-complexity`, threshold 6): the
 * panel's branch previously ran section → div.container → div.contact-grid →
 * div.contact-info → div.contact-info-item → div → p (depth 7). Same wrapper,
 * same `contact-info` / `contact-info-title` classNames, same child order —
 * the DOM is byte-identical.
 *
 * The rows arrive as `children` (rather than an items array) so the decorative
 * emoji literals stay in the page, where the existing `web/no-hardcoded-strings`
 * cover already accounts for them. This component needs no suppression.
 *
 * @module portals/marketing-website/components/ContactInfoPanel
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {string} props.title - Translated panel title.
 * @param {React.ReactNode} props.children - `<ContactInfoItem>` rows.
 * @returns {React.JSX.Element}
 */
export default function ContactInfoPanel({ title, children }) {
  return (
    <div className="contact-info">
      <h2 className="contact-info-title">{title}</h2>
      {children}
    </div>
  );
}

ContactInfoPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
